import React, { lazy, useEffect, Suspense } from 'react';
import { AreaState, AreaReducer } from '@Components/area_search/reducer';
import { InitialSearchState, SearchReducer } from '@Components/search_components/reducer';
import axios from 'axios';

import { Props } from '../props';
import s from './style.module.css';

// components
const Breadcrumb = lazy(() => import('@Components/breadcrumb/view'));
const Pager = lazy(() => import('@Components/pager/view'));
const Page = lazy(() => import('@Components/pc/page/view'));
const CourseCard = lazy(() => import('./components/course_card/view'));
const SortBox = lazy(() => import('./components/sort_box/view'));
const SearchMenu = lazy(() => import('../components/search_menu/view'));

const TitleImage = (props: { title: string }) => {
    return (
        <>
            <div className={s.page_title}>
                <h1>{props.title}</h1>
            </div>
        </>
    );
};

const List = (props: Props) => {
    const isProduction = process.env.NODE_ENV === 'production';
    const breadcrumbs = props.breadcrumbs;
    const [state, dispatch] = React.useReducer(AreaReducer, AreaState);
    const [lines, setLines] = React.useState([]);
    const [highways, setHighways] = React.useState([]);
    const [seriesList, setSeriesList] = React.useState([]);
    const [searchState, searchDispatch] = React.useReducer(SearchReducer, InitialSearchState([], [], []));

    useEffect(() => {
        Promise.all([axios.get('/api/v1/lines'), axios.get('/api/v1/highways'), axios.get('/api/v1/series')]).then(
            (res) => {
                setLines(res[0].data.lines);
                setHighways(res[1].data.highways);
                setSeriesList(res[2].data.seriesList);

                searchDispatch({
                    type: 'RESET',
                    payload: InitialSearchState(res[0].data.lines, res[1].data.highways, res[2].data.seriesList),
                });
            }
        );
    }, []);

    const pageTitle: string = props.breadcrumbs.slice(-1)[0].name;
    return (
        <Suspense fallback={''}>
            <Page
                contentHead={
                    <>
                        <TitleImage title={pageTitle} />
                        <Breadcrumb breadcrumbList={breadcrumbs} />
                    </>
                }
            >
                <div className={s.page_contents}>
                    <div className={s.left_side_contents}>
                        <SearchMenu
                            areaState={state}
                            areaDispatch={dispatch}
                            state={searchState}
                            dispatch={searchDispatch}
                            lines={lines}
                            highways={highways}
                            seriesList={seriesList}
                        />
                    </div>
                    <div className={s.right_side_contents}>
                        <div className={s.sort_box}>
                            <span className={s.count}>{props.pager.count}件</span>
                            {isProduction || <SortBox />}
                        </div>
                        <div className={s.course_cards}>
                            {props.courses.map((c, i) => (
                                <CourseCard key={`course-list-${i}`} {...c} />
                            ))}
                        </div>
                        <Pager total={props.pager.total} currentPage={props.pager.currentPage} />
                    </div>
                </div>
            </Page>
        </Suspense>
    );
};

export default List;
